module.exports = __webpack_public_path__ + "static/media/clover.df6a0d57.svg";